import z from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { OptionalPhoneNumber } from '../Phone';
import { zodBrandedUuid } from '../utils/Zod';

export const Foreclosure = z.object({
  id: zodBrandedUuid<ForeclosureId>(),
  referralDate: zodJSPlainDate,
  firstLegalActionDate: zodJSPlainDate.optional(),
  lawFirm: z.string().optional(),
  attorneyName: z.string().optional(),
  attorneyPhone: OptionalPhoneNumber,
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
  endDate: zodJSInstantDate.optional(), // date loan status changes out of foreclosure
});
export type Foreclosure = z.infer<typeof Foreclosure>;
